import { Controller } from '@hotwired/stimulus';

// Date inputs never match :placeholder-shown, so CSS cannot tell an empty field
// from a filled one. This flags the empty state for the stylesheet.
export default class extends Controller {
  connect() {
    this.toggle();
  }

  toggle() {
    this.element.classList.toggle('is-empty', !this.element.value);
  }
}
